<template>
  <main class="container">
    <div class="row text-left mb-2">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <h3 class="text-color-light font-size-24">
          <span class="span-hr-white-left"></span>DAFTAR PENJUAL
        </h3>
        <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <button
          type="button"
          class="btn btn-orange border-white float-right used-product"
        >
          LIHAT SEMUA PENJUAL
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <vue-horizontal class="horizontal" responsive>
          <router-link
            :to="`/kewirausahaan/toko/${item.id}`"
            class="item "
            v-for="(item, index) in list_merchant"
            :key="`list_merchant_${index}`"
          >
            <div class="image">
              <img class="center" :src="item.logo" alt="" />
            </div>
            <div class="card">
              <div class="content mt-5">
                <!-- name brand -->
                <div class="mb-4">
                  <div class="brand">
                    <div class="name text-center">
                      {{ item.name }}
                    </div>
                  </div>

                  <div class="product text-center">
                    {{ item.products_count }} Produk
                  </div>
                  <div class="text-center show-retail">
                    <router-link
                      :to="`/kewirausahaan/toko/${item.id}`"
                      type="button"
                      class="btn btn-outline-orange"
                    >
                      Lihat Toko
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </vue-horizontal>
      </div>
    </div>
  </main>
</template>
<script>
import VueHorizontal from "vue-horizontal";
import broker from "../../../../utils/broker";

export default {
  name: "DaftarPenjual",
  data() {
    return {
      list_merchant: [],
      items: [1, 2, 3, 4, 5, 6],
      title: "TOPI Capten GAMING motif Minecraft warna hijau tosca",
    };
  },
  mounted() {
    this.getDataListMerchant();
  },
  methods: {
    getDataListMerchant() {
      let self = this;
      broker.fetch.get(`/webschool/enterpreneur/merchant`).then((res) => {
        res.data.data.forEach((item) => {
          self.list_merchant.push(item);
        });
      });
    },
  },
  components: { VueHorizontal },
};
</script>
<style lang="scss" scoped>
main {
  padding: 24px;

  .card {
    z-index: -1;
  }

  .image {
    margin: 1rem 1rem -2rem 4rem;
    width: 80px;
    height: 80px;
    background: #dac52c;
    border-radius: 100%;
    text-align: center;

    img {
      width: 80px;
      height: 80px;
      border-radius: 100%;
    }
    .center {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

@media (min-width: 768px) {
  main {
    padding: 2% 0% 2% 0% !important;
  }
}
</style>
